import { useState } from "react";
import { Ion } from "@/components/Ion";
import { colors } from "@/lib/theme";

const DEFAULT_BODY =
  "Results are based on test area data and user inputs. Actual project conditions may vary. Verify square footage, production rates, and cleaning times through an on-site inspection before submitting a final customer proposal.";

// Port of EstimateDisclaimerGate.tsx — must be accepted before any pricing renders.
export default function EstimateDisclaimerGate({ onAccept, onBack, title = "Estimate Only" }) {
  const [checked, setChecked] = useState(false);
  return (
    <div className="p-4 pb-8">
      <div className="flex flex-col gap-3 rounded-[14px] border p-6" style={{ background: colors.card, borderColor: colors.warning }} data-testid="estimate-disclaimer-card">
        <span className="flex h-12 w-12 items-center justify-center self-start rounded-full border" style={{ background: "rgba(255, 200, 87, 0.10)", borderColor: colors.warning }}>
          <Ion name="warning-outline" size={26} color={colors.warning} />
        </span>
        <p className="text-[22px] font-black tracking-[0.3px] text-white">{title}</p>
        <p className="-mt-2 text-[11px] font-extrabold uppercase tracking-[1.2px]" style={{ color: colors.warning }}>Acknowledgment required before quote is shown</p>
        <div className="mt-1 rounded-[14px] border p-3.5" style={{ background: colors.bg, borderColor: colors.border }}>
          <p className="text-sm leading-5 text-white">{DEFAULT_BODY}</p>
        </div>
        <button onClick={() => setChecked((v) => !v)} data-testid="estimate-disclaimer-checkbox" className="mt-1.5 flex items-start gap-2.5 py-2 text-left">
          <span className="mt-px flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded border-2" style={checked ? { background: colors.accent, borderColor: colors.accent } : { background: colors.bg, borderColor: colors.border }}>
            {checked && <Ion name="checkmark" size={16} color="#000" />}
          </span>
          <span className="flex-1 text-sm leading-5 text-white">I understand this is an estimate only and will verify on-site before submitting a final customer proposal.</span>
        </button>
        <button disabled={!checked} onClick={onAccept} data-testid="estimate-disclaimer-accept"
          className="mt-1.5 flex items-center justify-center gap-2 py-3.5" style={checked ? { background: colors.accent } : { border: `1px solid ${colors.border}` }}>
          <Ion name="lock-open" size={16} color={checked ? "#000" : colors.textSecondary} />
          <span className="text-[13px] font-black tracking-[1.2px]" style={{ color: checked ? "#000" : colors.textSecondary }}>ACCEPT &amp; VIEW QUOTE</span>
        </button>
        {onBack && (
          <button onClick={onBack} data-testid="estimate-disclaimer-back" className="flex items-center justify-center gap-1.5 py-2.5">
            <Ion name="arrow-back" size={14} /><span className="text-[11px] font-bold tracking-[1.2px]" style={{ color: colors.textSecondary }}>BACK TO INPUTS</span>
          </button>
        )}
      </div>
    </div>
  );
}
